export default {
      id: "color_apple_rotated-usage",
      viewBox: "0 0 99.4 78.4",
      url: __webpack_public_path__ + "sprite.svg#color_apple_rotated",
      toString: function () {
        return this.url;
      }
    }